import { useState } from 'react';
import { EyeIcon, EyeOffIcon, CopyIcon, SyncIcon, KeyIcon } from './icons';
import IconButton from './IconButton';
import Badge from './Badge';

export default function SecretField({
  label,
  value,
  status = 'empty',
  onReveal,
  onCopy,
  onSync,
  onRotate,
  lastViewed,
  lastRotated,
}) {
  const [revealed, setRevealed] = useState(false);
  const [secretValue, setSecretValue] = useState(value || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleReveal = async () => {
    if (!revealed && onReveal && !secretValue) {
      setLoading(true);
      setError('');
      try {
        const nextValue = await onReveal();
        setSecretValue(nextValue || '');
      } catch (err) {
        setError(err?.message || 'No se pudo mostrar');
        return;
      } finally {
        setLoading(false);
      }
    }
    setRevealed((r) => !r);
  };

  const handleCopy = () => {
    if (secretValue && revealed) {
      navigator.clipboard.writeText(secretValue).catch(() => {});
      onCopy?.();
    }
  };

  const displayValue = loading ? 'Cargando...' : revealed && secretValue ? secretValue : '••••••••';

  const statusBadge =
    status === 'synced' ? (
      <Badge variant="success">Sincronizado</Badge>
    ) : status === 'pendingSync' ? (
      <Badge variant="warning">Pendiente</Badge>
    ) : status === 'error' ? (
      <Badge variant="danger">Error</Badge>
    ) : status === 'empty' ? (
      <Badge variant="neutral">Vacío</Badge>
    ) : (
      <Badge variant="secret">Cifrado</Badge>
    );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
      {label && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>{label}</span>
          {statusBadge}
        </div>
      )}
      <div className="aui-secret-field">
        <span className={['value', revealed ? 'revealed' : ''].filter(Boolean).join(' ')}>
          {displayValue}
        </span>
        <div className="actions">
          <IconButton onClick={handleReveal} title={revealed ? 'Ocultar' : 'Mostrar'}>
            {revealed ? <EyeOffIcon size={14} /> : <EyeIcon size={14} />}
          </IconButton>
          <IconButton onClick={handleCopy} disabled={!revealed || !secretValue} title="Copiar">
            <CopyIcon size={14} />
          </IconButton>
          {onRotate && (
            <IconButton onClick={onRotate} title="Cambiar contraseña">
              <KeyIcon size={14} />
            </IconButton>
          )}
          {onSync && (
            <IconButton onClick={onSync} title="Sincronizar">
              <SyncIcon size={14} />
            </IconButton>
          )}
        </div>
      </div>
      {error && <div style={{ fontSize: '0.75rem', color: 'var(--a-danger)' }}>{error}</div>}
      {(lastViewed || lastRotated) && (
        <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
          {lastViewed && <span>Última vista: {lastViewed}</span>}
          {lastRotated && <span style={{ marginLeft: '0.75rem' }}>Último rotado: {lastRotated}</span>}
        </div>
      )}
    </div>
  );
}
